import ProgrammeCard from '../ProgrammeCard';
import "../Programmes.scss";
import programmesOffered from "../Programmes.json";
import { Link, Outlet, useParams } from 'react-router-dom';
import baEnglish from "../../assets/Academics/UG Cards Thumbnails/baEnglish.jpeg";
import bscComputerScience from "../../assets/Academics/UG Cards Thumbnails/Bsc_Computer_Science.JPG";
import bscInformationTechnology from "../../assets/Academics/UG Cards Thumbnails/Bsc_Information_Technology.JPG";
import bscBioTechnology from "../../assets/Academics/UG Cards Thumbnails/Bsc_Bio_Technology.JPG";
import bscMicroBiology from "../../assets/Academics/UG Cards Thumbnails/Bsc_Micro_Biology.JPG";
import bscVisualCommunication from "../../assets/Academics/UG Cards Thumbnails/Bsc_Visual_Communication.JPG";
import bscNutrition from "../../assets/Academics/UG Cards Thumbnails/Bsc_Nutrition_Diabetics.JPG";
import bscHotelManagement from "../../assets/Academics/UG Cards Thumbnails/Bsc_Hotel_Management.JPG";
import bscMaths from "../../assets/Academics/UG Cards Thumbnails/Bsc_Mathematics.jpeg";
import bscChemistry from "../../assets/Academics/UG Cards Thumbnails/Bsc_Chemistry.JPG";
import bca from "../../assets/Academics/UG Cards Thumbnails/bca.JPG";
import bcom from "../../assets/Academics/UG Cards Thumbnails/bcom.jpeg";
import bba from "../../assets/Academics/UG Cards Thumbnails/bba.jpeg";
import bscAIDS from "../../assets/Academics/UG Cards Thumbnails/ai_profile_img.jpg"

const UG_Programmes = () => {

    const { courseName } = useParams();

    const ugThumbnailImages = {
        "baEnglish": baEnglish,
        "bscComputerScience": bscComputerScience,
        "bscInformationTechnology": bscInformationTechnology,
        "bscVisualCommunication": bscVisualCommunication,
        "bscHotelManagement": bscHotelManagement,
        "bscBioTechnology": bscBioTechnology,
        "bscNutrition": bscNutrition,
        "bscMicroBiology": bscMicroBiology,
        "bscMaths": bscMaths,
        "bscChemistry": bscChemistry,
        "bscAIDS": bscAIDS,
        "bca": bca,
        "bcom": bcom,
        "bba": bba,
    };

    return (
        <section className="programmesPageMainParent">
            {courseName ? (
                <article>
                    <Outlet />
                </article>
            ) : (
                <>
                    <article className="programmesParent">
                        <header style={{ width: "100%" }}>
                            <h2>UG Programmes</h2>
                        </header>
                        <article className="programmesOffered">
                            {programmesOffered.ugProgrammes.map((course, index) => (
                                <Link key={index} to={course.route} className="programmesCardMainContainer" style={{ textDecoration: "none", display: "flex", justifyContent: "center" }}>
                                    <ProgrammeCard bgImage={ugThumbnailImages[course.thumbNailImage]} course={course.course} />
                                </Link>
                            ))}
                        </article>
                    </article>
                </>
            )
            }
        </section >
    )
}

export default UG_Programmes
